const permissionsMap = {
	// management portal permissions
	'7d3e9ce6-6381-4380-8ef8-db953b830e0a': 'editLockedProgramSubmissionTemplates',
	'5c46f3d6-5fe6-4e0b-9469-ad6bbc0e2b32': 'listContacts',
	'87cc73f0-653e-410c-b8e9-2a9f82422bf6': 'viewContacts',
	'968909ea-5a62-4945-9810-eb85aee5e1a6': 'addContacts',
	'72013e1a-3a75-4aab-998f-a2d0ae09e84d': 'editContacts',
	'349c4a46-8ff3-49ac-8937-b3cb7c69fc0a': 'deleteContacts',
	'cb730696-9063-48ea-9718-c6a424cfcc5e': 'inactivateAgencyStaffMembers',
	'6e9d8413-7304-445c-8870-b65640aa5a23': 'listAgencies',
	'8bc28063-e745-4a6f-a98f-d4b5f9848b48': 'viewAgencies',
	'2285a585-9592-428f-aabb-bce014627428': 'addAgencies',
	'33293f8e-2c73-4b11-885f-a0672780ba28': 'editAgencies',
	'57d48f2a-da88-4b49-a45a-b94de018fe0b': 'deleteAgencies',
	'fa33ef39-a18f-4f29-83dc-894be4186311': 'listPrograms',
	'64b1faa3-6d7b-470f-9f68-4c73f25bd692': 'viewPrograms',
	'74c93981-42ee-42a2-9adf-880f9381f097': 'addPrograms',
	'540ac8b3-238e-445b-b00f-8ddc58c83cbd': 'editPrograms',
	'500f42f1-db84-43b0-965f-74f1f744f56a': 'deletePrograms',
	'6424b568-1d09-442b-8c60-7e3863d530d8': 'listUsers',
	'0d574e85-ac30-420b-846e-0f97cdeb9831': 'viewUsers',
	'c66e622b-7188-468b-b464-aa26cf338705': 'addUsers',
	'83be7671-67b7-423c-b11b-2c3d4dff19ed': 'editUsers',
	'ef246500-a386-47f0-bc18-6c905f13ba10': 'deleteUsers',
	// agency portal permissions
	'50b2b1fe-6e1e-4601-a0f3-ed2e95623978': 'agencyEditAgency',
	'6ffaf2d3-5003-4b54-832f-749bb9cfb07b': 'agencyListStaff',
	'58ab75ec-b3a9-47d4-afd4-cc2f4f34a279': 'agencyViewStaff',
	'3338be45-7075-4d3e-8af8-d03b42da0ad1': 'agencyAddStaff',
	'065dadef-46ce-461d-8c75-2a638fabc5cf': 'agencyEditStaff',
	'cc320112-c207-4837-83df-006096a5ffa3': 'agencyInactivateStaff',
	'3bf0a0c7-652c-4b80-80c1-8a225096eb4d': 'agencyListPrograms',
	'537a4f05-a681-43bb-b155-61bcae0f91e5': 'agencyViewPrograms',
	'b59e7830-eccc-4f9f-a494-5759a21f8ee3': 'agencyEditPrograms',
	'176d231e-92a3-4d33-9dc3-e7731c91c927': 'snapshotDocumentModules'
};

const mapPermissions = permissions => permissions.reduce( ( acc, {
	canExecute,
	isAvailable,
	useCaseId
} ) => {
	const key = permissionsMap[ useCaseId ];
	const value = {
		canExecute,
		isAvailable
	};

	return { ...acc, [ key ]: value };
}, {
	listTags: {
		canExecute: true,
		isAvailable: true
	},
	viewTags: {
		canExecute: true,
		isAvailable: true
	},
	addTags: {
		canExecute: true,
		isAvailable: true
	},
	editTags: {
		canExecute: true,
		isAvailable: true
	},
	deleteTags: {
		canExecute: true,
		isAvailable: true
	},
	listCalendarEvents: {
		canExecute: true,
		isAvailable: true
	},
	viewCalendarEvents: {
		canExecute: true,
		isAvailable: true
	},
	addCalendarEvents: {
		canExecute: false,
		isAvailable: false
	},
	editCalendarEvents: {
		canExecute: false,
		isAvailable: false
	},
	deleteCalendarEvents: {
		canExecute: false,
		isAvailable: false
	}
} );

export default mapPermissions;
